import Icon from '../components/Icon.vue'

Icon.register({
  'chevron-left': {
    width: 320,
    height: 512,
    paths: [
      {
        d: 'M34.5 239l194.4-194.3c9.4-9.4 24.6-9.4 33.9 0l22.7 22.7c9.4 9.4 9.4 24.5 0 33.9l-154 154.7 154 154.8c9.3 9.4 9.3 24.5 0 33.9l-22.7 22.7c-9.4 9.4-24.6 9.4-33.9 0l-194.3-194.4c-9.4-9.4-9.4-24.6 0-33.9z'
      }
    ]
  }
})
